import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcInfoFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12m8.94-3.49q.337.338.81.338.475 0 .812-.337.338-.338.338-.812t-.338-.812a1.1 1.1 0 0 0-.811-.337q-.474 0-.812.337a1.1 1.1 0 0 0-.337.812q0 .474.337.812M12 10.32q.378 0 .643.267a.88.88 0 0 1 .267.643v5.308q0 .376-.268.643a.88.88 0 0 1-.643.267.88.88 0 0 1-.643-.267.88.88 0 0 1-.266-.643v-5.308q0-.375.267-.643a.88.88 0 0 1 .644-.267",
    clipRule: "evenodd"
  }));
}
var IcInfoFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcInfoFill));

export { IcInfoFill as I };
